import { Card, Button, Typography, Space, Alert, Divider } from 'antd';
import React, { useEffect, useState } from 'react';

import { useAuth } from '../contexts/Auth';

const { Title, Text, Paragraph } = Typography;

interface TokenInfo {
  source: string;
  key: string;
  value: string | null;
  length: number;
}

const TokenDebugPage: React.FC = () => {
  const [tokens, setTokens] = useState<TokenInfo[]>([]);
  const { user, isAuthenticated } = useAuth();

  const refreshTokens = () => {
    const tokenSources: TokenInfo[] = [
      {
        source: 'localStorage',
        key: 'token',
        value: localStorage.getItem('token'),
        length: localStorage.getItem('token')?.length || 0
      },
      {
        source: 'localStorage',
        key: 'accessToken',
        value: localStorage.getItem('accessToken'),
        length: localStorage.getItem('accessToken')?.length || 0
      },
      {
        source: 'localStorage',
        key: 'refreshToken',
        value: localStorage.getItem('refreshToken'),
        length: localStorage.getItem('refreshToken')?.length || 0
      },
      {
        source: 'sessionStorage',
        key: 'token',
        value: sessionStorage.getItem('token'),
        length: sessionStorage.getItem('token')?.length || 0
      },
      {
        source: 'sessionStorage',
        key: 'accessToken',
        value: sessionStorage.getItem('accessToken'),
        length: sessionStorage.getItem('accessToken')?.length || 0
      },
      {
        source: 'sessionStorage',
        key: 'refreshToken',
        value: sessionStorage.getItem('refreshToken'),
        length: sessionStorage.getItem('refreshToken')?.length || 0
      }
    ];

    setTokens(tokenSources);
  };

  const clearAllTokens = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('refreshToken');
    refreshTokens();
  };

  const testApiCall = async () => {
    try {
      const response = await fetch('/api/v1/auth/current-user', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('accessToken') || localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      });
      
      console.log('API Test Response Status:', response.status);
      const data = await response.json();
      console.log('API Test Response Data:', data);
    } catch (error) {
      console.error('API Test Error:', error);
    }
  };

  useEffect(() => {
    refreshTokens();
  }, []);

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <Title level={2}>Token Debug Sayfası</Title>
      
      <Alert
        message="Bu sayfa sadece debug amaçlıdır"
        description="Token'ların durumunu kontrol etmek ve sorunları tespit etmek için kullanılır."
        type="info"
        showIcon
        style={{ marginBottom: '24px' }}
      />

      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Card title="Kullanıcı Durumu">
          <p><strong>Kimlik Doğrulandı:</strong> {isAuthenticated ? 'Evet' : 'Hayır'}</p>
          <p><strong>Kullanıcı:</strong> {user ? JSON.stringify(user, null, 2) : 'Yok'}</p>
        </Card>

        <Card 
          title="Token Durumu" 
          extra={
            <Space>
              <Button onClick={refreshTokens}>Yenile</Button>
              <Button danger onClick={clearAllTokens}>Tümünü Temizle</Button>
              <Button type="primary" onClick={testApiCall}>API Test</Button>
            </Space>
          }
        >
          {tokens.map((token, index) => (
            <div key={index} style={{ marginBottom: '16px' }}>
              <Text strong>{token.source}.{token.key}:</Text>
              <br />
              {token.value ? (
                <>
                  <Text code style={{ fontSize: '12px', wordBreak: 'break-all' }}>
                    {token.value.substring(0, 50)}...
                  </Text>
                  <br />
                  <Text type="secondary">Uzunluk: {token.length}</Text>
                </>
              ) : (
                <Text type="secondary">Yok</Text>
              )}
              {index < tokens.length - 1 && <Divider />}
            </div>
          ))}
        </Card>

        <Card title="Diğer Bilgiler">
          <p><strong>RememberMe:</strong> {localStorage.getItem('rememberMe')}</p>
          <p><strong>Selected Database ID:</strong> {localStorage.getItem('selectedDatabaseId')}</p>
          <p><strong>Current URL:</strong> {window.location.href}</p>
        </Card>
      </Space>
    </div>
  );
};

export default TokenDebugPage;